var sliderContainer = document.querySelector(".item-slider");
if (sliderContainer) {
    var slider = tns({
        container: sliderContainer,
        items: 3,
        autoplay: false,
        center: false,
        mouseDrag: true,
        loop: true,
        arrowKeys: true,
        nav: false,
        controlsPosition: "top",
        controlsContainer: "#categories-control",
        gutter: 20,
        responsive: {
            320: {
                items: 2,
            },
            576: {
                items: 3,
            },
            768: {
                items: 3,
            },
            980: {
                items: 4,
            },
            1280: {
                items: 5,
            },
            1440: {
                items: 6,
            },
            1920: {
                items: 7,
            },
        },
    });
}

var cartToast = document.querySelectorAll(".addedToCart");
if (cartToast.length > 0) {
    var myAlert = document.getElementById("addedToCartAlert");
    var bsAlert = new bootstrap.Toast(myAlert);

    for (var i = 0; i < cartToast.length; i++) {
        cartToast[i].addEventListener("click", function () {
            bsAlert.show();
        });
    }
}

// Credit card Handle Begin

document.addEventListener("DOMContentLoaded", () => {
    const selectors = {
        cardNumberInput: "#creditCard-Number",
        cardNumberDisplay: "#cardCredit .card-number",
        cardHolderInput: "#creditCard-Name",
        cardHolderDisplay: "#cardCredit .card-holder > span:nth-child(2)",
        expiryCardInput: "#creditCard-Expire",
        expiryCardDisplay: "#cardCredit .expiry .expiry-on",
        cvcInput: "#creditCard-CVV",
        cvcDisplay: "#cardCredit .cvc > span:nth-child(2)",
    };

    const elements = {};
    const selectorsExist = () => {
        for (const key in selectors) {
            elements[key] = document.querySelector(selectors[key]);
            if (!elements[key]) {
                return false;
            }
        }
        return true;
    };

    if (selectorsExist()) {
        const handleCardNumberInput = (e) => {
            const key = e.keyCode || e.charCode;
            const isDigit =
                (key >= 48 && key <= 57) || (key >= 96 && key <= 105);
            const isDelete = key === 8 || key === 46;
            const text = e.target.value;
            const len = text.length;

            if (isDigit || isDelete) {
                if (isDigit && (len === 4 || len === 9 || len === 14)) {
                    elements.cardNumberInput.value = text + " ";
                }
            } else {
                return false;
            }
        };

        const handleCardNumberDisplay = (e) => {
            const key = e.keyCode || e.charCode;
            const isDigit =
                (key >= 48 && key <= 57) || (key >= 96 && key <= 105);
            const isDelete = key === 8 || key === 46;
            const text = e.target.value;
            const len = text.length;
            const digits = "XXXX XXXX XXXX XXXX".split("");

            if (isDigit || isDelete) {
                if (isDigit && (len === 4 || len === 9 || len === 14)) {
                    digits[len] = " ";
                }

                for (let i = 0; i < len; i++) {
                    digits[i] = text.charAt(i);
                }

                elements.cardNumberDisplay.innerText = digits.join("");
            } else {
                return false;
            }
        };

        const handleCardHolderInput = (e) => {
            elements.cardHolderDisplay.innerText = e.target.value;
        };

        const handleExpiryMonthSelect = (e) => {
            elements.expiryCardInput.value =
                e.target.value.replace(/(\d{2})(?=\d)/g, "$1/") ?? "00";
            elements.expiryCardDisplay.innerText = e.target.value;
        };

        const handleCvcInput = (e) => {
            const text = e.target.value;
            const digits = ["_", "_", "_"];

            for (let i = 0; i < text.length; i++) {
                digits[i] = text.charAt(i);
            }

            elements.cvcDisplay.innerText = digits.join("");
        };
        elements.cardNumberInput.addEventListener(
            "keydown",
            handleCardNumberInput
        );
        elements.cardNumberInput.addEventListener(
            "keyup",
            handleCardNumberDisplay
        );
        elements.cardHolderInput.addEventListener(
            "keyup",
            handleCardHolderInput
        );
        elements.expiryCardInput.addEventListener(
            "keyup",
            handleExpiryMonthSelect
        );
        elements.cvcInput.addEventListener("keyup", handleCvcInput);
    }
});

// Credit card Handle End

// Product Image Slider Begin

const imgs = document.querySelectorAll(".product-grid .img-slider");
const imgBtns = [...imgs];

imgBtns.forEach((imgItem) => {
    imgItem.addEventListener("click", (event) => {
        if (imgItem.classList.contains("active")) {
            imgItem.classList.remove("active");
            imgItem.setAttribute("aria-current", "false");
        } else {
            // Remove 'active' class and set 'aria-current' to "false" for all other imgItems
            imgBtns.forEach((item) => {
                item.classList.remove("active");
                item.setAttribute("aria-current", "false");
            });
            // Add 'active' class and set 'aria-current' to "true" for the clicked imgItem
            imgItem.classList.add("active");
            imgItem.setAttribute("aria-current", "true");
        }
        event.preventDefault();
    });
});

// Product Image Slider End

// If you wish to write some custom code please place this file at the bottom.
import "./custom";
